export enum SpecialFacilityAccess {
  WheelchairAccessible = 'Wheelchair Accessible',
  SameDayAppointment = 'Same Day Appointment/Walk-Ins Accepted',
  ExtendedWeekendHours = 'Extended or Weekend Hours',
  TeenClinicHours = 'Teen Clinic/Hours Available',
}

export enum CldbHistoryOfChanges {
  OrganizationActivated = 'Organization Activated',
  OrganizationCreated = 'Organization Created',
  OrganizationDeactivated = 'Organization Deactivated',
  OrganizationEdited = 'Organization',
  OrganizationLocationEdited = 'Location',
  OrganizationHoursEdited = 'Hours of Operation',
  OrganizationPublished = 'Organization Published',
  OrganizationServicesEdited = 'Services',
  OrganizationUnpublished = 'Organization Unpublished',
}

export const RelatedPrograms = [
  { value: false, programName: 'CHC (Community Health Choices)' },
  { value: false, programName: 'FQHC (Federal Qualified Health Center)' },
  { value: false, programName: 'Title V Funding' },
  { value: false, programName: 'Ryan White Funding' },
];

export const SiteTypes = [
  'CHC/FQHC',
  'Correctional Facility-based',
  'Faith-based',
  'Free-Standing Family Planning Organization',
  'Health Department (State, County, or Local)',
  'Hospital-based',
  'Other',
  'Other Private Nonprofit',
  'Planned Parenthood',
  'School-based',
  'Tribal Health Center',
  'University-based',
];

export enum NoaFileType {
  Creation = 'creation',
  Removal = 'removal',
}
